// Generic UI/runtime configuration: pagination defaults, timeouts, settings keys,
// and viewport-derived layout helpers.

export const PER_PAGE_DEFAULT = 15;
export const INACTIVITY_TIMEOUT = 1000 * 60 * 60; // 60 minutes
export const VERSION_CHECK_INTERVAL = 1000 * 60 * 5; // 5 minutes

export const Settings = {
  maxNumberForMessages: "maxNumberForMessages",
  automatedClientMessages: "automatedClientMessages",
  notificationSettings: "notificationSettings",
};

// mui-datatables decides when to actually hide the table header and switch
// to its "simple" card layout using the MUI theme's "sm" breakpoint, not
// this value. Keep them equal (see getMuiTheme in globalStyleTables.tsx) —
// otherwise widths between the two thresholds (e.g. ~690px, the Galaxy Z
// Fold 5's unfolded screen) get "simple" mode requested but never applied,
// leaving a visible <thead> mixed with card-styled body cells.
export const MOBILE_BREAKPOINT_PX = 767;

const PORTRAIT_QUERY = "(orientation: portrait)";

// Reads orientation fresh each call, unlike a module-level matchMedia() constant.
export function isPortraitLayout(): boolean {
  return window.matchMedia(PORTRAIT_QUERY).matches;
}

export function getTableLayoutOnMobile(isMobile: boolean): "simple" | "standard" {
  return isMobile && isPortraitLayout() ? "simple" : "standard";
}
